export const formatAmount = (amount: number, minimumFractionDigits = 0, maximumFractionDigits = 10): string => {
  return amount.toLocaleString('en-US', { minimumFractionDigits, maximumFractionDigits })
}
